'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'face-glasses';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e377';
var svgPathData = ['M32 256c0-27.9 4.5-54.8 12.7-80l3.3 0 0 144 200 0 6.4-4.8 32-24 1.6-1.2 1.6 1.2 32 24 6.4 4.8 200 0 0-144 3.3 0c8.3 25.2 12.7 52.1 12.7 80 0 141.4-114.6 256-256 256S32 397.4 32 256zM88.1 96C135.1 37.5 207.2 0 288 0S440.9 37.5 487.9 96L318.1 96c-2 2-12 12-30 30l-1.6-1.2-32-24-6.4-4.8-159.9 0zm68.1 282.8C185.1 420.6 233.3 448 288 448s102.9-27.4 131.8-69.2l-39.5-27.3C360 380.9 326.2 400 288 400s-72-19.1-92.2-48.5l-39.5 27.3z', 'M72 96l-24 0 0 32-24 0 0 48 24 0 0 144 200 0 6.4-4.8 32-24 1.6-1.2 1.6 1.2 32 24 6.4 4.8 200 0 0-144 24 0 0-48-24 0 0-32-209.9 0c-2 2-12 12-30 30l-1.6-1.2-32-24-6.4-4.8-176 0zm408 48l0 128-136 0-16-12 0-106.1 9.9-9.9 142.1 0zM96 272l0-128 136 0 16 12 0 104-16 12-136 0zm96-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceGlasses = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;